"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DedupMultiMap = exports.MultiMap = void 0;
const model_1 = require("../data/model");
class MultiMap {
    constructor() {
        this.inner = new Map();
        this.size = 0;
    }
    add(key, value) {
        let s = this.inner.get(key);
        if (s === undefined) {
            s = new Set();
            this.inner.set(key, s);
        }
        if (!s.has(value)) {
            s.add(value);
            this.size = this.size + 1;
        }
    }
    delete(key, value) {
        let s = this.inner.get(key);
        if (s === undefined) {
            return false;
        }
        let ret = s.delete(value);
        if (s.size === 0) {
            this.inner.delete(key);
        }
        if (ret) {
            this.size = this.size - 1;
        }
        return ret;
    }
    deleteKey(key) {
        const vals = this.inner.get(key);
        if (vals !== undefined) {
            this.size = this.size - vals.size;
        }
        return this.inner.delete(key);
    }
    get(key) {
        let result = this.inner.get(key);
        if (result === undefined) {
            return new Set();
        }
        else {
            return new Set(result);
        }
    }
    hasKey(key) {
        return this.inner.has(key);
    }
    has(key, value) {
        const kv = this.inner.get(key);
        return kv !== undefined && kv.has(value);
    }
    asMap() {
        return new Map(this.inner.entries());
    }
    keys() {
        return this.inner.keys();
    }
    values() {
        return this.inner.values();
    }
    entries() {
        return this.inner.entries();
    }
    clone() {
        const clone = new MultiMap();
        for (const [k, s] of this.inner.entries()) {
            clone.inner.set(k, new Set(s));
        }
        return clone;
    }
}
exports.MultiMap = MultiMap;
class DedupMultiMap {
    constructor() {
        this.inner = new Map();
    }
    add(key, value) {
        let s = this.inner.get(key);
        if (s === undefined) {
            s = new model_1.HashedSet();
            this.inner.set(key, s);
        }
        s.add(value);
    }
    delete(key, value) {
        let s = this.inner.get(key);
        if (s === undefined) {
            return false;
        }
        let ret = s.remove(value);
        if (s.size() === 0) {
            this.inner.delete(key);
        }
        return ret;
    }
    deleteKey(key) {
        return this.inner.delete(key);
    }
    get(key) {
        let result = this.inner.get(key);
        if (result === undefined) {
            return new Set();
        }
        else {
            return new Set(result.values());
        }
    }
    hasKey(key) {
        return this.inner.has(key);
    }
    has(key, value) {
        const kv = this.inner.get(key);
        return kv !== undefined && kv.has(value);
    }
    asMap() {
        return new Map(this.inner.entries());
    }
    keys() {
        return this.inner.keys();
    }
}
exports.DedupMultiMap = DedupMultiMap;
//# sourceMappingURL=multimap.js.map